module.exports = __webpack_public_path__ + "static/media/20x24no2.f5223f39.jpg";